import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import bubble from "../../../images/Login/bubble-registrieren.png";
import "./RegisterBubble.scss";

function RegisterBubble() {
  const { i18n, t } = useTranslation("register");

  return (
    <section id="RegisterBubble">
      <div className="d-flex flex-column justify-content-center align-items-center mt-xxl-5">
        <div className="image-wrapper">
          <img src={bubble} alt="" />
        </div>
        <div className="text-wrapper">
          <p className="bubble-text">{t("bubble.text_1")}</p>
          <p className="bubble-text">{t("bubble.text_2")}</p>
          <p className="bubble-text">{t("bubble.text_3")}</p>
          <p className="bubble-text">{t("bubble.text_4")}</p>
        </div>
        <div className="button-wrapper">
          <a
            href={
              i18n.language === "de-DE"
                ? "https://www.ischebeck.de/mikropfahl-online-bemessung/"
                : "https://www.ischebeck.de/en/micropile-online-design/"
            }
            target="_blank"
            rel="noreferrer"
          >
            <button className="login-button" type="button">
              <div className="verticallyAligned">
                <div style={{ fontWeight: "bold" }}>{t("bubble.button")}</div>
                <div style={{ marginLeft: "25px" }}>
                  <FontAwesomeIcon color="yellow" icon={faChevronRight} />
                </div>
              </div>
            </button>
          </a>
        </div>
      </div>
    </section>
  );
}

export default RegisterBubble;
